import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import "./customer.scss"

const Customer = () => {
    const [customer, setCustomer] = useState({});
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAllRef = async () => {
            try {
                const [companyRes] = await Promise.all([
                    axiosInstance.get(`ergo/company`)
                ]);

                setCustomer(companyRes.data || {});
                setLoading(false);
            } catch (err) {
                console.log(err);
            }
        }
        fetchAllRef()
    }, [])

    if (isLoading) return <div className="loading" />

    const hasData = customer && Object.keys(customer).length > 1;
    if (!hasData)
        return (
            <div className="customer">
                <div className="container">
                    <div className="header">
                        <h1>Kundenstammdaten</h1>
                    </div>
                    <div className="noData">
                        <span>Keine Kundendaten gefunden.</span>
                    </div>
                </div>
            </div>
        );

    return (
        <div className="customer">
            <div className="container">
                <div className="header">
                    <h1>Kundenstammdaten</h1>
                </div>
                <div className="grid">
                    <div className="row">
                        <div className="card">
                            <div className="customer">
                                <BusinessRoundedIcon />
                                <div className="value">
                                    <h3>{customer.COMPANY1}</h3>
                                    <span>Kundennummer: {customer.COMPANYID}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="row">
                        <div className="card">
                            <div className="top">
                                <span>Rechnungsdaten</span>
                                <ReceiptLongRoundedIcon />
                            </div>
                            {customer.ADDRESS &&
                                <>
                                    <label>Adresse</label>
                                    <p>
                                        {customer.ADDRESS}<br />
                                        {customer.ZIP} {customer.PLACE}<br />
                                        {customer.PROVINCE}, {customer.STATE}
                                    </p>
                                </>
                            }
                            {customer.TAXID &&
                                <>
                                    <label>MwStNr.</label>
                                    <p>{customer.TAXID}</p>
                                </>
                            }
                            {customer.VATID &&
                                <>
                                    <label>Steuernummer</label>
                                    <p>{customer.VATID} </p>
                                </>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="card">
                            <div className="top">
                                <span>Kontaktdaten</span>
                                <CallOutlinedIcon />
                            </div>
                            {customer.EMAIL &&
                                <>
                                    <label>E-Mail</label>
                                    <Link to={"mailto:" + customer.EMAIL}>{customer.EMAIL}</Link>
                                </>
                            }
                            {customer.PHONE &&
                                <>
                                    <label>Telefonnummer</label>
                                    <Link to={"tel:" + customer.PHONE}>{customer.PHONE} </Link>
                                </>
                            }
                        </div>
                        {customer.CONTACTS.length > 0 &&
                            <div className="card">
                                <div className="top">
                                    <span>Kontakte</span>
                                    <PermContactCalendarOutlinedIcon />
                                </div>
                                <div className="list">
                                    {customer.CONTACTS.map((contact, index) => (
                                        <div className="item" key={index}>
                                            <div className="badge">
                                                <span>{contact.Vorname?.[0] + contact.Nachname?.[0]}</span>
                                            </div>
                                            <div className="content">
                                                <h4>{contact.Vorname} {contact.Nachname}</h4>
                                                <div className="line">
                                                    <CallOutlinedIcon />
                                                    <Link to={"tel:" + contact.Telefon}>{contact.Telefon}</Link>
                                                    <Link to={"tel:" + contact.Telefon2}>{contact.Telefon2}</Link>
                                                </div>
                                                <div className="line">
                                                    <EmailOutlinedIcon />
                                                    <Link to={"mailto:" + contact.Email}>{contact.Email}</Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>}
                    </div>
                </div>
                <div className="grid">
                    <div className="row">
                        <div className="card">
                            <div className="top">
                                <span>Links</span>
                                <LinkRoundedIcon />
                            </div>
                            <div className="links">
                                <Link to="/deliverynotes">
                                    <button>
                                        <SummarizeRoundedIcon />
                                        <span>Lieferscheine</span>
                                    </button>
                                </Link>
                                <Link to="/bills">
                                    <button className="light">
                                        <ReceiptLongRoundedIcon />
                                        <span>Rechnungen</span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Customer